import { PublicFaqSection } from "@/components/public/faq/PublicFaqSection";
import { publicFaqQuery } from "@/api-queries/faq";
import { defineSection } from "@/ssr/define-section";

function HomeFaqSection() {
  return (
    <PublicFaqSection.Component
      placement="home"
      copyKey="home.faq"
      flat
    />
  );
}

export const FaqSection = defineSection({
  Component: HomeFaqSection,
  queries: [publicFaqQuery],
});
